"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ContentMarkup;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _markdownToJsx = _interopRequireDefault(require("markdown-to-jsx"));

function ContentMarkup(_ref) {
  var children = _ref.children,
      content = _ref.content,
      isMarkdown = _ref.isMarkdown,
      gridColumnProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "content", "isMarkdown"]);
  var finalContent = content || children;

  if (!finalContent) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, gridColumnProps, isMarkdown && /*#__PURE__*/_react["default"].createElement(_markdownToJsx["default"], null, finalContent), !isMarkdown && finalContent);
}

;
ContentMarkup.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].node)]),
  content: _propTypes["default"].string,
  isMarkdown: _propTypes["default"].bool
};
ContentMarkup.defaultProps = {
  children: null,
  content: null,
  isMarkdown: true
};